// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--2TU9l","text":"_93444fe79c--text--9sKmY"};